<template>
  <div class="navHeader" v-if="showNav">
    <van-nav-bar v-if="displayNavBar"
      @click-left="onClickLeft" 
      @click-right="onClickRight" 
      :title="title" 
      :border="false" 
      left-arrow 
    >
      <img v-if="showHome" class="home" src="../../assets/home.png" alt="" slot="right" >
    </van-nav-bar>
    <router-view name="extendNav"/>
  </div>
</template>

<script>
import { displayHeader } from "@/utils/common";
export default {
  name: "NavHeader",
  data() {
    return {
      title: "标题",
      showNav: true,
      showHome: true
    };
  },
  computed: {
    displayNavBar() {
      return displayHeader(this.title);
    }
  },
  watch: {
    $route: "route"
  },
  methods: {
    route() {
      const { meta } = this.$route;
      if (meta.hasOwnProperty("title")) this.$data.title = meta.title;
      if (meta.hasOwnProperty("showNav")) this.$data.showNav = meta.showNav;
      if (meta.hasOwnProperty("showHome")) this.$data.showHome = meta.showHome;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      window.location.href = 'https://m.csair.com';
    }
  }
};
</script>

<style lang="less" scoped>
.navHeader {
  background: rgb(35, 88, 146);
  /deep/.van-nav-bar {
    background-color: transparent;
    .van-icon {
      color: white;
    }
    .van-nav-bar__title {
      color: white;
    }
    .van-nav-bar__right {
      line-height: 40px;
    }
  }
  .home {
    height: 18PX;
  }
}
</style>
